import { combineReducers } from 'redux';
import Layout from './layout/reducer';
import devicesReducer from './DevicesPaymentStore/devicesReducer';
import lifeTimeReducer from './LifetimeSubscriber/lifeTimeReducer';
import getInTouchReducer from './GetInTouch/getInTouchReducer';
import userUninstallReducer from './UnistallSurvey/uninstallReducer';
import getPaymentIssueReducer from './PaymentIssues/paymentIssuesReducer';
import betaEmailReducer from './iOS/iOSBetaEmails/betaEmailReducer';
import missingAppReducer from './iOS/iOSmissingApp/missingAppReducer';
import { webVisitorsReducer, webMiniWidgetReducer, webBetaSalesReducer, applicationDownloaderReducer, webWeeklyInsightReducer, androidUserAnalyticsReducer, androidRecentActiveReducer, newBetaJoinerReducer } from './Dashboard/dashboardReducer'

const rootReducer = combineReducers({
    Layout,
    devices: devicesReducer,
    lifeTime: lifeTimeReducer,
    getInTouch: getInTouchReducer,
    userUninstall: userUninstallReducer,
    paymentIssues: getPaymentIssueReducer,
    betaEmail: betaEmailReducer,
    missingApp: missingAppReducer,
    webVisitors: webVisitorsReducer,
    miniWidget: webMiniWidgetReducer,
    betaSales: webBetaSalesReducer,
    applicationInstallation: applicationDownloaderReducer,
    webWeeklyInsight: webWeeklyInsightReducer,
    androidUserAnalytics: androidUserAnalyticsReducer,
    androidRecentActive: androidRecentActiveReducer,
    newBetaJoiner: newBetaJoinerReducer
});

export default rootReducer;